__webpack_require__.p = "/pointsmall/_next/";